module.exports = __webpack_public_path__ + "img/features-anki.34d2d19c.svg";